<template>
  <div>
    <expenses-navigation />
    <div class="d-flex justify-content-end mb-3" />
    <loader v-if="loading" />
    <template v-else>
      <template v-if="!isTotalCostsEmpty">
        <ib-card
          :animation="false"
          class="mb-4 pt-4 pb-3"
        >
          <distribution-of-total-costs />
        </ib-card>
        <ib-card
          :animation="false"
          class="mb-4 pt-4 pb-3"
        >
          <timeline-of-total-costs />
        </ib-card>
        <ib-card
          :animation="false"
          class="mb-4 pt-4 pb-2"
        >
          <total-costs-table />
        </ib-card>
      </template>
      <empty-placeholder v-else />
    </template>
  </div>
</template>

<script>
import DistributionOfTotalCosts from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/TotalCost/DistributionOfTotalCosts'
import EmptyPlaceholder from '@/views/Home/StoryMode/FinancialPlan/Components/EmptyPlaceholder'
import ExpensesNavigation
  from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/TotalCost/ExpensesNavigation.vue'
import Loader from '@/components/Loader'
import MixinApiCalculations from '@/mixins/apiCalculations'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'
import TimelineOfTotalCosts from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/TotalCost/TimelineOfTotalCosts'
import TotalCostsTable from '@/views/Home/StoryMode/FinancialPlan/Tables/TotalCostsTable'
import { mapState } from 'vuex'

export default {
  name: 'ExpensesTotalCosts',

  components: {
    ExpensesNavigation,
    DistributionOfTotalCosts,
    EmptyPlaceholder,
    Loader,
    TimelineOfTotalCosts,
    TotalCostsTable
  },

  mixins: [MixinIdeaRoles, MixinApiCalculations],

  data () {
    return {
      loading: false
    }
  },

  computed: {
    ...mapState(['idea']),

    isTotalCostsEmpty () {
      return this.idea.storyMode.forecast.totalCosts.calculation.totalCosts === 0
    }
  }
}
</script>
